export enum SchedulerMessagesEnum {
  ScheduleManager = 1,
  ScheduleForm = 2,
  SelectedSite = 3,
  ChooseDate = 4,
  Reports = 5,
  CopySchedule = 6,
  Planning = 7,
  Scheduling = 8,
  Venues = 9,
  LengthBreakdown = 10,
  Edit = 11,
  Cancel = 12,
  SetNotPrivate = 13,
  SePrivate = 14,
  Cut = 15,
  Paste = 16,
  Delete = 17,
  EditOpeningHours = 18,
  CancelBusinessDay = 19,
  CreateSnapshot = 20,
  DeployPlanning = 21,
  DeploySmartPlanning = 1156,
  DeploySmartSuccess = 1157,
  DeploySmartPartial = 1158,
  DeploySmartErrorCode = 1159,
  DeploySmartErrorCount = 1160,
  DeploySmartErrorIds = 1161,
  DeploySmartTestMode = 1162,
  DeploySmartTestModeLabel = 1163,
  DeploySmartTestModeHint = 1164,
  DeploySmartEventDateTime = 1165,
  DeploySmartEventMasterCol = 1166,
  DeploySmartConflictCol = 1167,
  DeploySmartNoEventDetails = 1168,
  DeploySmartRunningTest = 1169,
  DeploySmartDebugData = 1177, // Debug data
  DeploySmartEventsCount = 1178, // {{count}} event(s)
  SummaryReport = 22,
  ScheduleComparisonReport = 23,
  ScheduleValidationReport = 24,
  LoadSnapshotCap = 25,
  ApplyScheduleTemplate = 26,
  BulkSchedule = 27,
  AllowOverlapping= 28,
  UpdateVenueFailed= 29,
  SwapEventsBetweenVenues = 30,
  CopyMultiSite = 31,
  UpdateEMOrTimeOfEventFailed = 32,
  AutoScheduleSpecialEvents = 33,
  AiScheduleSpecialEventsTitle = 1002,
  AiScheduleIncludeSpecialEvents = 1003,
  AiScheduleSpecialEventsHint = 1004,
  AiScheduleBuilder = 240,
  AiSchedulePlanningScope = 1005,
  AiScheduleMoviePool = 1006,
  AiScheduleStrategy = 1007,
  AiScheduleGenerateReview = 1008,
  AiScheduleSchedulePeriod = 1009,
  AiScheduleSingleDay = 1010,
  AiScheduleFullWeek = 1011,
  AiScheduleWeekendOnly = 1012,
  AiScheduleCustomRange = 1013,
  AiScheduleCinemas = 1014,
  AiScheduleSelectAll = 1015,
  AiScheduleHowToStart = 1016,
  AiScheduleBuildFromScratch = 1017,
  AiScheduleBuildFromScratchDesc = 1018,
  AiScheduleBasedOnPreviousWeek = 1019,
  AiScheduleBasedOnPreviousWeekDesc = 1020,
  AiScheduleBasedOnReferenceWeek = 1021,
  AiScheduleBasedOnReferenceWeekDesc = 1022,
  AiScheduleReferenceWeek = 1023,
  AiScheduleReferenceWeekHint = 1024,
  AiScheduleReferenceWeekStartDate = 1025,
  AiScheduleExistingEventsTitle = 1026,
  AiScheduleClearRegenerate = 1027,
  AiScheduleClearRegenerateDesc = 1028,
  AiScheduleFillEmptySlots = 1029,
  AiScheduleFillEmptySlotsDesc = 1030,
  AiScheduleIgnoreAllowOverlaps = 1031,
  AiScheduleIgnoreAllowOverlapsDesc = 1032,
  AiScheduleCompletePlanningScope = 1033,
  AiScheduleLoadingMovies = 1034,
  AiScheduleRetry = 1035,
  AiScheduleMoviesIncluded = 1036,
  AiScheduleIncludeAll = 1037,
  AiScheduleExcludeAll = 1038,
  AiScheduleSelectPage = 1139,
  AiScheduleIncludeCol = 1039,
  AiScheduleMovieCol = 1040,
  AiScheduleWeekCol = 1041,
  AiScheduleRatingCol = 1042,
  AiScheduleRuntimeCol = 1043,
  AiSchedulePriorityCol = 1044,
  AiScheduleMinDayCol = 1045,
  AiScheduleMaxDayCol = 1046,
  AiScheduleMinWeekCol = 1047,
  AiScheduleMinPTDayCol = 1048,
  AiScheduleHallSizeCol = 1049,
  AiScheduleTimeSlotCol = 1050,
  AiScheduleFormatCol = 1051,
  AiScheduleModeCol = 1052,
  AiScheduleNewBadge = 1053,
  AiScheduleHighPriority = 1054,
  AiScheduleMediumOption = 1055,
  AiScheduleLowPriority = 1056,
  AiScheduleAnyOption = 1057,
  AiScheduleLargeOption = 1058,
  AiScheduleSmallOption = 1059,
  AiScheduleAnyTimeSlot = 1060,
  AiScheduleMorningSlot = 1061,
  AiScheduleAfternoonSlot = 1062,
  AiSchedulePrimeTimeSlot = 1063,
  AiScheduleLateNightSlot = 1064,
  AiScheduleFamilyHoursSlot = 1065,
  AiScheduleSoftMode = 1066,
  AiScheduleHardMode = 1067,
  AiScheduleFailedLoadMovies = 1068,
  AiScheduleNoMoviesFound = 1069,
  AiSchedulePlanningStrategyTitle = 1070,
  AiScheduleRevenueMax = 1071,
  AiScheduleRevenueMaxDesc = 1072,
  AiScheduleBalancedProgramLabel = 1073,
  AiScheduleBalancedProgramDesc = 1074,
  AiScheduleOccupancyOpt = 1075,
  AiScheduleOccupancyOptDesc = 1076,
  AiScheduleNewReleasesPush = 1077,
  AiScheduleNewReleasesPushDesc = 1078,
  AiScheduleAudienceDiversity = 1079,
  AiScheduleAudienceDiversityDesc = 1080,
  AiScheduleRiskLevelTitle = 1081,
  AiScheduleConservative = 1082,
  AiScheduleConservativeDesc = 1083,
  AiScheduleBalancedRisk = 1084,
  AiScheduleBalancedRiskDesc = 1085,
  AiScheduleExperimental = 1086,
  AiScheduleExperimentalDesc = 1087,
  AiScheduleOperatingHoursTitle = 1088,
  AiScheduleOverrideSiteHours = 1089,
  AiScheduleUsingCustomHours = 1090,
  AiScheduleUsingSiteHours = 1091,
  AiScheduleWeekdays = 1092,
  AiScheduleWeekends = 1093,
  AiScheduleFirstShow = 1094,
  AiScheduleLastShowEndsBy = 1095,
  AiScheduleHoursTo = 1096,
  AiScheduleSpecialHandlingTitle = 1097,
  AiScheduleProtectFamilyHours = 1098,
  AiScheduleProtectFamilyHoursHint = 1099,
  AiScheduleProtectPremiumSlots = 1100,
  AiScheduleProtectPremiumSlotsHint = 1101,
  AiScheduleAvoidBackToBack = 1102,
  AiScheduleAvoidBackToBackHint = 1103,
  AiSchedulePrioritizeNewReleases = 1104,
  AiSchedulePrioritizeNewReleasesHint = 1105,
  AiScheduleReadyToGenerate = 1106,
  AiScheduleReadyToGenerateDesc = 1107,
  AiScheduleGenerateBtn = 1108,
  AiScheduleRetryGeneration = 1109,
  AiScheduleTotalShows = 1110,
  AiScheduleMoviesScheduled = 1111,
  AiScheduleScreenHours = 1112,
  AiScheduleVenueUtilization = 1113,
  AiScheduleAvgShowsPerMovie = 1114,
  AiScheduleSiteAvgOccupancy = 1115,
  AiSchedulePastShows = 1116,
  AiSchedulePoolAvgOccupancy = 1117,
  AiSchedulePredictedOccupancyLabel = 1118,
  AiScheduleAcrossGeneratedShows = 1119,
  AiScheduleScheduleQuality = 1120,
  AiScheduleAllHardMet = 1121,
  AiScheduleHardConstraintsViolated = 1122,
  AiScheduleHardLabel = 1123,
  AiScheduleSoftLabel = 1124,
  AiScheduleWarningsAndNotes = 1125,
  AiScheduleMoviePrefix = 1126,
  AiScheduleVenuePrefix = 1127,
  AiScheduleKeyDecisions = 1128,
  AiScheduleGeneratedShowsTitle = 1129,
  AiScheduleLockedCount = 1130,
  AiScheduleLockHint = 1131,
  AiScheduleLockedWillBePreserved = 1132,
  AiScheduleRegenerateBtn = 1133,
  AiScheduleApplyToSchedule = 1134,
  AiScheduleGeneratingStatus = 1135,
  AiScheduleDeployingSpecialEvents = 1136,
  AiScheduleGenerationFailed = 1137,
  AiScheduleFailedDeploySpecialEvents = 1138,
  Confirm = 34,
  Remark = 35,
  NoPermissionForCancelEvent = 36,
  ScheduleCancelWarning= 37,
  ScheduleDTOfEventWarning= 38,
  CancelEventForbidden = 336,
  ScheduleAllocCancelWarning= 337,
  ScheduleAllocDTOfEventWarning= 338,
  ModifyEventError = 39,
  ModifyEventWarning = 40,
  DeallocateEventError = 41,
  /*Edit site hours component*/

  EditSiteHours = 100,
  EditSiteInfo = 101,
  Day = 102,
  StartTime = 103,
  EndTime = 104,

  /*EventMaster component*/
  Week = 120,
  Min = 121,

  /*schedule comparison component*/
  ScheduleComparison = 130,
  ScheduleComparisonInfo = 131,
  Compare = 132,
  ScheduledNotPlanned= 133,
  Name= 134,
  Venue= 135,
  Date= 136,
  NoRecordsFound = 137,
  PlannedNotSchedule = 138,

  /*schedule deploy component*/
  DeployPlannedSchedule = 160,
  DeployPlannedScheduleInfo = 161,
  ErrorStartDateBeforeEndDate = 162,
  ErrorRangeLimit= 163,
  ErrorOverlapping= 164,
  SkipOverlap= 165,
  DeploySchedule= 166,

  /*schedule validation  component*/
  ScheduleValidationReportCap = 180,
  ScheduleWeek = 181,
  Length = 182,
  WeekNumber= 183,
  MoviesNotRescheduled= 184,
  ScheduleEmptyIntervals= 185,
  Time= 186,
  MaxConcurrent = 187,
  NumberOfEvents= 188,

  /*create / load snapshot*/
  CreateNewSnapshot = 200,
  SnapshotNameCap = 201,
  LoadSnapshot = 202,
  SnapshotName = 203,
  Created = 204,

  /*Monitor component */
  ScheduleMonitor = 230,
  ResetStatus = 231,
  SoldQuantity = 232,
  SoldQuantityOfCapacity = 233,
  SoldRemotelyOfCapacity = 234,
  SoldRemotely = 235,
  EventsCopied = 236,
  SpecialEventAlreadyScheduled,
  InvalidPosition= 238,


  /*service messages*/
  DoneCap= 900,
  // Cinema opening hours were successfully updated
  HoursUpdated = 901,
  // Snapshot was successfully created
  SnapshotCreated = 902,
  // Snapshot successfully loaded
  SnapshotLoaded = 903,
  // Planned schedule successfully deployed
  PlannedScheduleDeployed = 908,

  // Are you sure?
  AreYouSure = 904,
  // This will clear the entire schedule day
  ClearScheduleWarning = 905,
  // The schedule has been cleared
  ScheduleCleared = 906,
 // {effectedEvents} events were selected
  eventsSelected = 907,
  // {{count}} events were updated
  eventsUpdated = 921,
  // {{count}} events were canceled
  eventsCanceled = 909,


  // event length breakdown
  MovieName = 910,
  EventTime = 911,
  MovieNetLength = 912,
  TrailerLength = 913,
  IntermissionLength = 914,
  ClassAdvertisingLength = 915,
  ClassCleaningLength = 916,
  VenueCleaningLength = 917,
  TotalLength = 918,

  // 'Yes, clear it!'
  ConfirmClear = 919,

  // Format not supported in this venue ({{format}})
  formatNotSupportedInVenue = 920,


  // venue info
  VenueName = 930,
  VenueType = 931,
  CleaningTime = 932,
  Formats = 933,
  Attributes = 934,



  // HC-1095 special event info
  OrderedBy = 1140, // Ordered By
  CreatedBy = 1141, // Created By
  CopyToClipboard = 1142, // Copy to Clipboard
  CopiedToClipboard = 1143, // Copied to clipboard
  ResultStatus = 1144, // Status
  NoSpecialEventsToSchedule = 1145, // No special events to schedule in the selected date range
  ErrorSpecialEventAlreadyScheduled = 1146, // Special event already scheduled
  ErrorNoVenueOrMovie = 1147, // No venue or event master assigned
  ErrorSpecialEventOverlapping = 1148, // Event overlaps another event
  ErrorGenericFailure = 1149, // Failed to schedule
  SpecialEventNotFound = 1150, // Event Not Found
  AutoAssignSpecialEvents = 1151, // Auto-Assign Special Events
  AutoAssignPreview = 1152, // Preview
  AutoAssignExecute = 1153, // Execute assignment
  AutoAssignNoSpecialEvents = 1154, // No unscheduled special events
  AutoAssignNoEventsFound = 1155, // No matching programmed events found

  // TOMIX-35 Fill Day
  FillDay = 1170, // Fill Day
  FillDayEventMaster = 1171, // Event
  FillDayInterval = 1172, // Start every (minutes)
  FillDayPreview = 1173, // {{count}} events will be created
  FillDayCreated = 1174, // {{count}} events were created
  FillDaySkippedOverlap = 1175, // {{count}} time slots were skipped due to overlapping events
  FillDayNoSlots = 1176, // No available time slots in the selected range

  /*errors*/
  OperationFailed= 1000,
  ErrorScheduleBeforeOpening= 1001,
}

